import { Box, Button, Carousel, Image, PaginationIndicator, SheetContainer, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useOnboardingTourController } from "./OnboardingTour.controller";
import styles from "./OnboardingTour.module.css";

export const OnboardingTour = () => {
  const {
    active,
    carouselItems,
    carouselIndex,
    carouselRef,
    setCarouselIndex,
    isFirstStep,
    isLastStep,
    onSkipTour,
    onPrevious,
    onNext,
  } = useOnboardingTourController();
  const i18n = useI18n();

  return (
    <SheetContainer active={active} position="center" size={540} fill hideClose>
      <Box mixin={{ padding: 8 }}>
        <Stack alignItems="center" justifyContent="center" gap={6}>
          <Text variant="headline_1">{i18n.trans(t("flights_airline_portal_onboarding_title"))}</Text>
          <Carousel
            ref={carouselRef}
            className={styles.carousel}
            ariaLabel="Onboarding Tour Carousel"
            nextButtonAriaLabel="Next Step"
            previousButtonAriaLabel="Previous Step"
            onAfterNavigate={({ index }) => setCarouselIndex(index)}
          >
            {carouselItems.map((carouselItem, index) => (
              <Carousel.Item key={`kCarouselItem-${index}`}>
                <Stack
                  className={styles.carouselItemContainer}
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Stack.Item>
                    <Stack className={styles.carouselItemIllustration} alignItems="center" justifyContent="center">
                      <Image asset={carouselItem.asset} width={30} />
                    </Stack>
                  </Stack.Item>
                  <Stack.Item
                    className={styles.carouselItemText}
                    mixin={{ paddingBlockStart: 4, paddingBlockEnd: 4, paddingInlineStart: 6 }}
                  >
                    <Stack direction="column" justifyContent="center">
                      <Text variant="headline_3">{carouselItem.title}</Text>
                      <Text variant="body_1" color="neutral_alt">
                        {carouselItem.text}
                      </Text>
                    </Stack>
                  </Stack.Item>
                </Stack>
              </Carousel.Item>
            ))}
          </Carousel>
          <Stack direction="row" alignItems="center" justifyContent="space-between" className={styles.footer}>
            <PaginationIndicator total={carouselItems.length} activeIndex={carouselIndex} />
            <Stack direction="row" gap={2}>
              <Button variant="tertiary" size="large" onClick={onSkipTour}>
                {i18n.trans(t("flights_airline_portal_onboarding_button_secondary"))}
              </Button>
              {!isFirstStep && (
                <Button variant="secondary" size="large" onClick={onPrevious}>
                  {i18n.trans(t("flights_airline_portal_airline_view_onboarding_button_back"))}
                </Button>
              )}
              <Button size="large" onClick={onNext}>
                {isLastStep
                  ? i18n.trans(t("flights_airline_portal_airline_view_onboarding_button_finish"))
                  : i18n.trans(t("flights_airline_portal_onboarding_button_primary"))}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </SheetContainer>
  );
};
